import { render, staticRenderFns } from "./CallDataTable.vue?vue&type=template&id=a3f30832&scoped=true&"
import script from "./CallDataTable.vue?vue&type=script&lang=js&"
export * from "./CallDataTable.vue?vue&type=script&lang=js&"
import style0 from "./CallDataTable.vue?vue&type=style&index=0&id=a3f30832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f30832",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDataTable,VIcon,VSpacer,VTextField,VToolbar,VToolbarTitle})
